import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import "./SearchBar.css";

export default function SearchBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const routes = {
    home: "/",
    who: "/about",
    about: "/about",
    whoweare: "/about",
    vision: "/about",
    mission: "/about",
    invention: "/our-invention",
    inventions: "/our-invention",
    howinventionworks: "/our-invention",
    role: "/our-role",
    ourrole: "/our-role",
    services: "/our-role",
    rsc: "/shopping-centre",
    shopping: "/shopping-centre",
    shop: "/shopping-centre",
    shoppingcentre: "/shopping-centre",
    contact: "/contact",
    contactus: "/contact",
    login: "/login",
    faq: "/faq",
    overview: "/overview",
    terms: "/terms-of-use",
    privacy: "/privacy-policy",
    copyright: "/copyright",
  };

  const runSearch = () => {
    const keyword = search.toLowerCase().replace(/\s+/g, "");
    if (!keyword) return;

    if (routes[keyword]) {
      navigate(routes[keyword]);
      setSearch("");
    } else {
      alert(t("searchNotFound"));
    }
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      runSearch();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    runSearch();
  };

  return (
    <form className="search-container" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder={t("search")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
        className="search-input"
      />
      <button type="submit" className="search-icon-btn" aria-label={t("searchAriaLabel")}>
        <FaSearch />
      </button>
    </form>
  );
}
